import { useQuery } from '@tanstack/react-query'
import {
  PROFILE_SOCIAL_ECONOMIC_QUERY_KEY,
  fetchProfileRiskSocialEconomic,
} from '../services/socialEconomic.service'
import type { ProfilePropertiesRequest } from '../types/riskProfileProperties.types'

export function useRiskProfileSocialEconomicQuery(request: ProfilePropertiesRequest | null) {
  return useQuery({
    queryKey: [PROFILE_SOCIAL_ECONOMIC_QUERY_KEY, request],
    queryFn: () => {
      if (request === null) {
        throw new Error('Profile social/economic request is required')
      }
      return fetchProfileRiskSocialEconomic(request)
    },
    enabled: request !== null && (request.hazards === undefined || request.hazards.length > 0),
  })
}
